// eslint-disable-next-line import/prefer-default-export
export const trackOnMixpanel = async (eventShown, attrs = null) => {
	const Mixpanel = await import("utils/Mixpanel");
	Mixpanel.default.track(eventShown, attrs);
};
